var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackToMentorblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 60",
    x: "0px",
    y: "0px",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 16,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,25a5.935,5.935,0,0,0-.35187-2.009l6.68354-4.48676a1,1,0,1,0-1.10938-1.66406l-6.57257,4.38171-.00159-.00238a6.95867,6.95867,0,0,1-9.25519.03736A6.34214,6.34214,0,0,0,7,25.21484V29a2.00229,2.00229,0,0,0,2,2h8a2.00229,2.00229,0,0,0,2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,2H5A3.00328,3.00328,0,0,0,2,5V23a3.00328,3.00328,0,0,0,3,3v-.78516A8.37483,8.37483,0,0,1,6.83057,20.0083l.2417-.30243A6.99872,6.99872,0,1,1,19.86853,17.3374l3.24426-2.16113A3,3,0,1,1,26.44043,20.169l-5.521,3.70605A7.869,7.869,0,0,1,21,25v1H43a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,43,2ZM28,13H26a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-5H26a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2ZM41,18H32a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Zm0-5H32a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Zm0-5H32a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7934,39.855a4,4,0,1,0-5.5868,0A4.99933,4.99933,0,0,0,7,44v1a.99974.99974,0,0,0,1,1h8a.99974.99974,0,0,0,1-1V44A4.99933,4.99933,0,0,0,14.7934,39.855ZM12,39a2,2,0,1,1,2-2A2.00229,2.00229,0,0,1,12,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7934,39.855a4,4,0,1,0-5.5868,0A4.99933,4.99933,0,0,0,19,44v1a.99974.99974,0,0,0,1,1h8a.99974.99974,0,0,0,1-1V44A4.99933,4.99933,0,0,0,26.7934,39.855ZM24,39a2,2,0,1,1,2-2A2.00229,2.00229,0,0,1,24,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7934,39.855a4,4,0,1,0-5.5868,0A4.99933,4.99933,0,0,0,31,44v1a.99974.99974,0,0,0,1,1h8a.99974.99974,0,0,0,1-1V44A4.99933,4.99933,0,0,0,38.7934,39.855ZM36,39a2,2,0,1,1,2-2A2.00229,2.00229,0,0,1,36,39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToMentorblack);
export default __webpack_public_path__ + "static/media/backToMentorblack.4edd41eb1ec4ce693fd23ee56972d459.svg";
export { ForwardRef as ReactComponent };